<template>
    <div class="insurance-program-select">
        <select-input
            :active-index="activeIndex"
            :choices="choices"
            @change="onChange"></select-input>
    </div>
</template>

<script>
import http from "@/http"

export default {
    props: {
        defaultChoices: {
            default: () => [
                { key: "", badge: null, label: "All" }
            ],
            type: Array
        },
        disableFetch: {
            default: false,
            type: Boolean
        }
    },

    data () {
        return {
            activeIndex: 0,
            choices: this.defaultChoices
        }
    },

    mounted () {
        this.loadChoices()
    },

    methods: {
        onChange (index) {
            this.activeIndex = index

            this.$emit("change", this.choices[index].key)
        },

        async loadChoices () {
            try {
                const { data } = await http("/api/insurance-programs")

                this.choices = [
                    { key: "", badge: null, label: "All" },
                    ...data.map((data) => {
                        return {
                            key: data.key,
                            badge: null,
                            label: data.label
                        }
                    })
                ]
            } catch (ex) {
                this.$modalManager.add({ state: "bad", header: "Error", body: ex })
            }
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/InsuranceProgramSelect.vue